import {
	accountTransitionGet,
	TransitionStatus,
} from '@Services/accountTransition';

export class AccountTransitionCache {
	private static instance: AccountTransitionCache;

	private fetchActive: boolean;
	private cachedValue: TransitionStatus | null;

	private constructor() {
		this.fetchActive = true;
		this.cachedValue = null;
	}

	private async refreshCache(): Promise<void> {
		const { data } = await accountTransitionGet();
		this.cachedValue = data.status;
	}

	public async isTransitionAccount(): Promise<boolean> {
		try {
			// ? Fetch acc state if empty cache or fetch switch is on
			if (!this.cachedValue || this.fetchActive)
				await this.refreshCache();
			this.fetchActive = false; // ? stop fetching
			return this.cachedValue === 'new';
		} catch (error) {
			console.error(error);
			return false;
		}
	}

	public reset(): void {
		this.fetchActive = true;
		this.cachedValue = null;
	}

	public static getInstance() {
		if (!this.instance) {
			this.instance = new AccountTransitionCache();
		}
		return this.instance;
	}
}
